export interface CustomerSignInResponse {
  id: string;
  loginTime: string;
  retryTime: number;
  userId: string;
}
